import { useSyncExternalStore } from 'react';

interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

type TransitionPhase =
  | 'idle'
  | 'login-to-center'
  | 'pulsating'
  | 'center-to-header';

interface LoginTransitionState {
  visible: boolean;
  loginSettled: boolean;
  error: string | null;
  phase: TransitionPhase;
  loginLogoRect: Rect | null;
  headerLogoRect: Rect | null;
}

const initialState: LoginTransitionState = {
  visible: false,
  loginSettled: false,
  error: null,
  phase: 'idle',
  loginLogoRect: null,
  headerLogoRect: null,
};

let state = { ...initialState };
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach(l => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

// Actions
export function showTransition() {
  state = {
    ...initialState,
    visible: true,
    phase: 'idle',
  };
  emit();
}

export function settleTransition(error?: string) {
  state = { ...state, loginSettled: true, error: error ?? null };
  emit();
}

export function resetTransition() {
  state = { ...initialState };
  emit();
}

export function setLoginLogoRect(rect: Rect) {
  state = { ...state, loginLogoRect: rect };
  emit();
}

export function setHeaderLogoRect(rect: Rect) {
  state = { ...state, headerLogoRect: rect };
  emit();
}

export function setTransitionPhase(phase: TransitionPhase) {
  state = { ...state, phase };
  emit();
}

// Hook
export function useLoginTransitionStore() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

// Direct access for imperative reads
export function getTransitionState() {
  return state;
}
